<template>
  <div class="notifications-content md-layout">
    <md-card class="md-layout-item md-size-50 md-medium-size-66 md-small-size-100">
      <ul
        class="dropdown-menu dropdown-menu-right notification-menu"
      >
        <span class="notification-title ">Notifications ({{ unreadNotifications }})</span>
        <div
          v-infinite-scroll="loadMore"
          class="scrollable"
          infinite-scroll-disabled="disableScroll"
          infinite-scroll-distance="10"
        >
          <div v-if="todayNotifications.length">
            <span class="sub-title">Today</span>
            <li
              v-for="notification in todayNotifications"
              :key="notification._id"
              :class="{'bold': !notification.read}"
            >
              <a :href="notification.link">
                <notifications-menu :notification="notification" />
              </a>
            </li>
          </div>
          <div v-if="earlierNotifications.length">
            <span class="sub-title">Earlier</span>
            <li
              v-for="notification in earlierNotifications"
              :key="notification._id"
              :class="{'bold': !notification.read}"
            >
              <a :href="notification.link">
                <notifications-menu :notification="notification" />
              </a>
            </li>
          </div>
        </div>
      </ul>
    </md-card>
  </div>
</template>

<script>
import NotificationsMenu from '../molecules/notifications-menu';
import infiniteScroll from 'vue-infinite-scroll'

export default {
  components: { NotificationsMenu },
  directives: { infiniteScroll },
  data() {
    return {
      unreadNotifications: 0,
      todayNotifications: [],
      earlierNotifications: [],
      disableScroll: false,
      lastNotificationId: null,
    }
  },
  mounted() {
    setTimeout(() => {
      this.$store
          .dispatch("queryAPI", { url: "/rest/notfication/read" })
          .then(() => {
            this.todayNotifications.map(n => n.read = true);
            this.earlierNotifications.map(n => n.read = true);
            this.unreadNotifications = 0;
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          });
    }, 3100)
  },
  methods: {
    loadMore() {
      this.$store
          .dispatch("queryAPI", { url: "/rest/notfication", options: this.lastNotificationId
                ? { limit: 15, after: this.lastNotificationId }
                : { limit: 15 }
          }).then(res => {
              this.unreadNotifications = res.filter(n => n.read == false).length;
              const isToday = (someDate) => {
                const today = new Date();
                const myDate = new Date(someDate)
                return myDate.getDate() == today.getDate() &&
                    myDate.getMonth() == today.getMonth() &&
                    myDate.getFullYear() == today.getFullYear();
              }
              for (let i = 0; i <= res.length; i++) {
                if (res[i] && res[i].createdAt) {
                  const created = res[i].createdAt;
                  if (isToday(created)) {
                    this.todayNotifications = [...this.todayNotifications, res[i]];
                  } else {
                    this.earlierNotifications = [...this.earlierNotifications, res[i]];
                  }
                }
              }
              this.lastNotificationId = res.slice(-1)[0]._id;
              this.disableScroll = res.length % 15 != 0;
             })
            .catch(err => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                icon: "add_alert",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "danger"
              });
            });
    },
  }
}
</script>

<style lang="scss">
 .notifications-content {
   display: flex;
   align-content: center;
   flex-direction: column;
  .dropdown-menu {
    max-height: calc(100vh - 130px);
    .scrollable {
      overflow-y: auto;
      max-height: calc(100vh - 130px);

    }
  }
   .notification-title {
     font-size: 22px;
     font-weight: 500;
     padding-left: 26px;
     display: block;
     margin-bottom: 20px;
   }
   .sub-title {
     padding-left: 26px;
     font-weight: 500;
     font-size: 14px;
   }
   .bold {
     a {
       font-weight: 500;
     }
   }
 }

 .notification-menu {
   display: flex !important;
   flex-direction: column;
   position: relative !important;
   box-shadow: none !important;
 }
</style>